import { render, staticRenderFns } from "./form-sent.vue?vue&type=template&id=4898750b"
import script from "./form-sent.vue?vue&type=script&lang=js"
export * from "./form-sent.vue?vue&type=script&lang=js"
import style0 from "./form-sent.vue?vue&type=style&index=0&id=4898750b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports